<template>
  <div class="header-shoppingcart">
    <b-button id="HeaderShoppingCartButton" class="counter-wrapper" variant="outline-control" size="xs" v-bind="$attrs" v-on="$listeners">
      <lazy-icon icon="cart"/>
      <counter :count="itemCount"/>
    </b-button>

    <b-popover
      v-if="lastAction.type"
      target="HeaderShoppingCartButton"
      container="HeaderShoppingCartButton"
      placement="bottomleft"
      triggers="manual"
      :show="popover.show"
    >
      <i18n tag="p" :path="`${tPath}.popover.actiontype.${lastAction.type.toLowerCase()}`">
        <template v-for="(prop, pKey) in popoverActiontypeProperties" #[pKey]>
          <strong :key="pKey">{{ prop }}</strong>
        </template>
      </i18n>
      <b-button :href="$attrs.href" variant="primary" size="xs" block>{{ $t(`${tPath}.popover.basketbutton`) }}</b-button>
    </b-popover>
  </div>
</template>

<script>
import { COMPONENT_HEADERSHOPPINGCART_POPOVER_HIDE_TIMEOUT } from '@/constants'

import { flatten } from '@/assets/js/helper/object'

import Counter from '@/components/private/Counter'

export default {
  name: 'HeaderShoppingCart',
  inheritAttrs: false,
  components: {
    Counter
  },
  data () {
    return {
      popover: {
        show: false,
        timeout: null
      }
    }
  },
  computed: {
    itemCount () {
      return this.$store.getters['shoppingcart/getItemCount']
    },
    lastAction () {
      return this.$store.getters['shoppingcart/getLastAction']
    },
    popoverActiontypeProperties () {
      return flatten(this.lastAction)
    }
  },
  methods: {
    showPopover () {
      if (this.lastAction.type) {
        if (this.popover.timeout) clearTimeout(this.popover.timeout)

        this.popover.show = true
        this.popover.timeout = setTimeout(() => {
          this.popover.show = false
        }, COMPONENT_HEADERSHOPPINGCART_POPOVER_HIDE_TIMEOUT)
      } else {
        if (this.popover.timeout) clearTimeout(this.popover.timeout)
        this.popover.show = false
      }
    }
  },
  created () {
    this.$store.dispatch('shoppingcart/getMinimal')
  },
  watch: {
    lastAction () {
      this.showPopover()
    }
  }
}
</script>

<style lang="scss">
$headershoppingcart-popover-min-width: 250px !default;

.header-shoppingcart {
  #HeaderShoppingCartButton {
    &:not(:hover):not(:active) {
      background-color: transparent;
      border-color: transparent;
    }
  }

  .popover {
    min-width: $headershoppingcart-popover-min-width;

    .arrow {
      // icon font-size = 125%, defined by bootstrap-vue
      // 1.25em / 2 = 0.625em
      margin-left: calc($btn-border-width + $btn-padding-x-xs + 0.625em - ($popover-arrow-width * 0.5));
      margin-right: calc($btn-border-width + $btn-padding-x-xs + 0.625em - ($popover-arrow-width * 0.5));
    }
  }
}
</style>
